import React from 'react';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import TextField from '@material-ui/core/TextField';
import Button from "@material-ui/core/Button";
import {deleteACctransaction, loadCctransactionsData, saveACctransaction, updateACctransaction} from "../../redux/modules/cctransaction";
import {connect} from "react-redux";
import PropTypes from "prop-types";
import {bindActionCreators} from "redux";
import {DEFAULT_VESPAAN_SERVER} from "../../utils/MainConstants";
//import {loadCamerasData} from "../../redux/modules/camera";
import {withStyles} from "@material-ui/core";
import DynamicTable from "./DynamicTable";
import InputAdornment from '@material-ui/core/InputAdornment';
//import React from 'react';
import classNames from 'classnames'
import FormControl from "@material-ui/core/FormControl";
import InputLabel from "@material-ui/core/InputLabel";
import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";
//import {loadLocationsData} from "../../redux/modules/location";


const styles = theme => ({
    main: {
        width: 'auto',
        display: 'block', // Fix IE 11 issue.
        marginLeft: theme.spacing.unit * 3,
        marginRight: theme.spacing.unit * 3,
        [theme.breakpoints.up(400 + theme.spacing.unit * 3 * 2)]: {
            width: 400,
            marginLeft: 'auto',
            marginRight: 'auto',
        },
    },
    paper: {
        marginTop: theme.spacing.unit * 8,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        padding: `${theme.spacing.unit * 2}px ${theme.spacing.unit * 3}px ${theme.spacing.unit * 3}px`,
    },
    avatar: {
        margin: theme.spacing.unit,
        backgroundColor: theme.palette.secondary.main,
    },
    form: {
        width: '100%', // Fix IE 11 issue.
        marginTop: theme.spacing.unit,
    },
    submit: {
        marginTop: theme.spacing.unit * 3,
    },
    formControl: {
        margin: theme.spacing.unit,
        minWidth: 120,
    },
    selectEmpty: {
        marginTop: theme.spacing.unit * 2,
    },
    button: {
        marginTop: theme.spacing.unit * 3,
        marginLeft: theme.spacing.unit,
        backgroundColor:"#e2580d",
        color:"black",
    },
    root: {
        display: 'flex',
        flexWrap: 'wrap',
    },
    margin: {
        margin: theme.spacing.unit,
    },
    textField: {
        flexBasis: 200,
    },
});


/*
    private String vehicleId;
	private String creditCardId;
	private String companyId;
	private String approvedByUserId;
	private String rejectedByUserId;
	private String gpsLatitude;
	private String gpsLongitude;
	private Date transactionDate;
	private Date createdDate;
	private Date modifiedDate;
	private Date endDate;
	private String storageFee;
	private String hookupFee;
	private String milage;
	private String perMileFee;
	private String totalMilageFee;
	private String subTotal;
	private String taxRate;
	private String taxFee ;
	private String totalCost ;
	
 */

class CCTransactionForm extends React.Component {


    state = {

        //selectedLocation:{},
        selectedCctransaction:{},
        inputFieldShrinkState:true,
        numberShrink:false  //Jut sfor alter I can add a shrink flag for each filed.

    };
    


    constructor(props) {
        super(props);
        this.editRecord = this.editRecord.bind(this);
        this.deleteRecord = this.deleteRecord.bind(this);
        this.clearFields = this.clearFields.bind(this);
        this.refresh = this.refresh.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleUpdate = this.handleUpdate.bind(this);
        this.handleChangeMilage = this.handleChangeMilage.bind(this);
        this.handleChangeVehicleId = this.handleChangeVehicleId.bind(this);
        this.handleChangeCompanyId = this.handleChangeCompanyId.bind(this);
        this.handleChangeCreditCardId = this.handleChangeCreditCardId.bind(this);
        this.handleChangeApprovedByUserId = this.handleChangeApprovedByUserId.bind(this);
        this.handleChangeGpsLatitude = this.handleChangeGpsLatitude.bind(this);
        this.handleChangeGpsLongitude = this.handleChangeGpsLongitude.bind(this);
        this.handleChangeStorageFee = this.handleChangeStorageFee.bind(this);
        this.handleChangeHookupFee = this.handleChangeHookupFee.bind(this);
        this.handleChangePerMileFee = this.handleChangePerMileFee.bind(this);
        this.handleChangeTotalMilageFee = this.handleChangeTotalMilageFee.bind(this);
        this.handleChangeSubTotal = this.handleChangeSubTotal.bind(this);
        this.handleChangeTaxRate = this.handleChangeTaxRate.bind(this);
        this.handleChangeTaxFee = this.handleChangeTaxFee.bind(this);
        this.handleChangeTotalCost = this.handleChangeTotalCost.bind(this);
        //this.handleEinChange = this.handleEinChange.bind(this);


    }


    handleSubmit () {


        let { saveACctransaction } = this.props;

        var tempStream = this.state.selectedCctransaction ;
        //tempStream.locationId= this.state.selectedLocation.id;
        saveACctransaction(DEFAULT_VESPAAN_SERVER.url,  tempStream);

    };

    handleUpdate () {
        let { updateACctransaction } = this.props;

        var tempStream = this.state.selectedCctransaction ;
        //tempStream.locationId= this.state.selectedLocation.id;
        updateACctransaction(DEFAULT_VESPAAN_SERVER.url,  tempStream);

    };

    handleChangeVehicleId(event) {
        //event.preventDefault();
        this.setState(Object.assign(this.state.selectedCctransaction,{vehicleId:event.target.value}));
    }
    handleChangeCreditCardId(event) {
        //ereventDefault();
        this.setState(Object.assign(this.state.selectedCctransaction,{creditCardId:event.target.value}));
    }

    handleChangeCompanyId(event) {
        //event.preventDefault();
        this.setState(Object.assign(this.state.selectedCctransaction,{companyId:event.target.value}));
    }


    handleChangeApprovedByUserId(event) {
        //event.preventDefault();
        this.setState(Object.assign(this.state.selectedCctransaction,{approvedByUserId:event.target.value}));
    }

    handleChangeGpsLatitude(event) {
        //event.preventDefault();
        this.setState(Object.assign(this.state.selectedCctransaction,{gpsLatitude:event.target.value}));
    }

    handleChangeGpsLongitude(event) {
        //event.preventDefault();
        this.setState(Object.assign(this.state.selectedCctransaction,{gpsLongitude:event.target.value}));
    }

   handleChangeMilage(event) {
        //event.preventDefault();
        this.setState(Object.assign(this.state.selectedCctransaction,{milage:event.target.value}));
    }

    handleChangeStorageFee(event) {
        //event.preventDefault();
        this.setState(Object.assign(this.state.selectedCctransaction,{storageFee:event.target.value}));
    }

    handleChangeHookupFee(event) {
        //event.preventDefault();
        this.setState(Object.assign(this.state.selectedCctransaction,{hookupFee:event.target.value}));
    }

    handleChangePerMileFee(event) {
        //event.preventDefault();
        this.setState(Object.assign(this.state.selectedCctransaction,{perMileFee:event.target.value}));
    }

    handleChangeTotalMilageFee(event) {
        //event.preventDefault();
        this.setState(Object.assign(this.state.selectedCctransaction,{totalMilageFee:event.target.value}));
        this.setState({numberShrink:true});
    }

    /*handleChangeubTotal(event) {
        //event.preventDefault();
        this.setState({selectedLocation: event.target.value});
        //this.setState({selectedVideoControllerName: event.target.value.displayName});
    }*/


    handleChangeSubTotal(event) {
        //event.preventDefault();
        this.setState(Object.assign(this.state.selectedCctransaction,{subTotal:event.target.value}));
    }



    handleChangeTaxRate(event) {
        //event.preventDefault();
        this.setState(Object.assign(this.state.selectedCctransaction,{taxRate:event.target.value}));
        //this.setState({numberShrink:true});
    }

    handleChangeTaxFee(event) {
        //event.preventDefault();
        this.setState(Object.assign(this.state.selectedCctransaction,{taxFee:event.target.value}));
        //this.setState({numberShrink:true});
    }


    handleChangeTotalCost(event) {
        //event.preventDefault();
        this.setState(Object.assign(this.state.selectedCctransaction,{totalCost:event.target.value}));
        //this.setState({numberShrink:true});
    }



    handleLocationChange(event) {
        //event.preventDefault();
        this.setState({selectedLocation: event.target.value});
        //this.setState({selectedVideoControllerName: event.target.value.displayName});
    }




    clearFields = (e) => {
        e.preventDefault();
        this.setState(state => ({
            inputFieldShrinkState:true
        }));


        var tempSelectedCctransaction =   Object.assign({}, this.state.selectedCctransaction);
        Object.keys(tempSelectedCctransaction).map((key, index) => {
            tempSelectedCctransaction[key] = "" ;
        });
        this.setState({selectedCctransaction:tempSelectedCctransaction})




    };
    renderErrorFiled(data){


    }

    refresh(event) {
        let { loadCctransactionsData } = this.props;
        loadCctransactionsData(DEFAULT_VESPAAN_SERVER.url );
    }

    handleChangeAmount = prop => event => {
        this.setState({ [prop]: event.target.value });
    };


    render() {
        const {classes} = this.props;
        return (
        <React.Fragment>
        <Typography variant="h6" gutterBottom>
            Cctransaction Information
        </Typography>
    <Grid container spacing={24}>

        <Grid item xs={12} sm={12}>
            {/* < FormControl className = {classes.formControl}  required fullWidth >
                    < InputLabel htmlFor = "age-simple" > Location < /InputLabel>
                        < Select ref = {c => this.mySelect = c} value = {this.state.selectedLocation} onChange = {this.handleLocationChange}
                        inputProps = { { name: 'location', id : 'location', } } >
                        {this.props.locationsArray.map(n => (<MenuItem value= {n}   ref={n.id} inputProps = { { name: n.id , id :n.id  } } >{n.name}</MenuItem>))}

                        < /Select>
                < /FormControl>
                */}

        {/*
            <Grid container >
                <Grid item xs={5} sm={5} >
                    <TextField required id="number" name="number"  label="Number"  fullWidth  InputLabelProps={{ shrink: this.state.inputFieldShrinkState || this.state.numberShrink  }}  value={this.state.selectedCctransaction.cctransactionNumber} onChange={this.handleNumberChange}/>
                </Grid>
                <Grid item xs={2} sm={2} >
                </Grid>
                <Grid item xs={5} sm={5} >
                    <TextField required id="name" name="name"  label="Name on the cctransaction"  fullWidth  InputLabelProps={{ shrink: this.state.inputFieldShrinkState }}  value={this.state.selectedCctransaction.cctransactionName} onChange={this.handleCctransactionNameChange}/>
                </Grid>
            </Grid>


        private String storageFee;
        private String hookupFee;
        private String milage;
        private String perMileFee;
        private String totalMilageFee;
        private String subTotal;
        private String taxRate;
        private String taxFee ;
        private String totalCost ;
        private String vehicleId;
        private String creditCardId;
        private String companyId;
        private String approvedByUserId;
        private String rejectedByUserId;
        private String gpsLatitude;
        private String gpsLongitude;

         */}


    <Grid container >
        <Grid item xs={12} sm={12} >
            <TextField
        id="outlined-adornment-amount"
        className={classNames(classes.margin, classes.textField)}
        variant="outlined"
        label="Vehicle Id"
        value={this.state.selectedCctransaction.vehicleId}
        onChange={this.handleChangeVehicleId}
        InputProps={{
            startAdornment: <InputAdornment position="start"></InputAdornment>,
        }}
        />
        </Grid>
        <Grid item xs={12} sm={12} >
            <TextField
        id="outlined-adornment-amount"
        className={classNames(classes.margin, classes.textField)}
        variant="outlined"
        label="Credit Card Id"
        value={this.state.selectedCctransaction.creditCardId}
        onChange={this.handleChangeCreditCardId}
        InputProps={{
            startAdornment: <InputAdornment position="start"></InputAdornment>,
        }}
        />
        </Grid>
        <Grid item xs={12} sm={12} >
            <TextField
        id="outlined-adornment-amount"
        className={classNames(classes.margin, classes.textField)}
        variant="outlined"
        label="Tow Company Id"
        value={this.state.selectedCctransaction.companyId}
        onChange={this.handleChangeCompanyId}
        InputProps={{
            startAdornment: <InputAdornment position="start"> </InputAdornment>,
        }}
        />
        </Grid>
        <Grid item xs={12} sm={12} >
            <TextField
        id="outlined-adornment-amount"
        className={classNames(classes.margin, classes.textField)}
        variant="outlined"
        label="User Id"
        value={this.state.selectedCctransaction.approvedByUserId}
        onChange={this.handleChangeApprovedByUserId}
        InputProps={{
            startAdornment: <InputAdornment position="start"> </InputAdornment>,
        }}
        />
        </Grid>
        <Grid item xs={12} sm={12} >
            <TextField
        id="outlined-adornment-amount"
        className={classNames(classes.margin, classes.textField)}
        variant="outlined"
        label="gpsLatitude"
        value={this.state.selectedCctransaction.gpsLatitude}
        onChange={this.handleChangeGpsLatitude}
        InputProps={{
            startAdornment: <InputAdornment position="start"> </InputAdornment>,
        }}
        />
        </Grid>
        <Grid item xs={12} sm={12} >
            <TextField
        id="outlined-adornment-amount"
        className={classNames(classes.margin, classes.textField)}
        variant="outlined"
        label="gpsLongitude"
        value={this.state.selectedCctransaction.gpsLongitude}
        onChange={this.handleChangeGpsLongitude}
        InputProps={{
            startAdornment: <InputAdornment position="start"> </InputAdornment>,
        }}
        />
        </Grid>
        <Grid item xs={12} sm={12} >
            <TextField
        id="outlined-adornment-amount"
        className={classNames(classes.margin, classes.textField)}
        variant="outlined"
        label="Milage"
        value={this.state.selectedCctransaction.milage}
        onChange={this.handleChangeMilage}
        InputProps={{
            startAdornment: <InputAdornment position="start"> </InputAdornment>,
        }}
        />
        </Grid>
        <Grid item xs={12} sm={12} >
            <TextField
        id="outlined-adornment-amount"
        className={classNames(classes.margin, classes.textField)}
        variant="outlined"
        label="Storage Fee"
        value={this.state.selectedCctransaction.storageFee}
        onChange={this.handleChangeStorageFee}
        InputProps={{
            startAdornment: <InputAdornment position="start">$</InputAdornment>,
        }}
        />
        </Grid>
        <Grid item xs={12} sm={12} >
            <TextField
        id="outlined-adornment-amount"
        className={classNames(classes.margin, classes.textField)}
        variant="outlined"
        label="HookUp Fee"
        value={this.state.selectedCctransaction.hookupFee}
        onChange={this.handleChangeHookupFee}
        InputProps={{
            startAdornment: <InputAdornment position="start">$</InputAdornment>,
        }}
        />
        </Grid>

        <Grid item xs={12} sm={12} >
            <TextField
        id="outlined-adornment-amount"
        className={classNames(classes.margin, classes.textField)}
        variant="outlined"
        label="Per Mile Fee"
        value={this.state.selectedCctransaction.perMileFee}
        onChange={this.handleChangePerMileFee}
        InputProps={{
            startAdornment: <InputAdornment position="start">$</InputAdornment>,
        }}
        />
        </Grid>
        <Grid item xs={12} sm={12} >
            <TextField
        id="outlined-adornment-amount"
        className={classNames(classes.margin, classes.textField)}
        variant="outlined"
        label="Total Mileage Fee"
        value={this.state.selectedCctransaction.totalMilageFee}
        onChange={this.handleChangeTotalMilageFee}
        InputProps={{
            startAdornment: <InputAdornment position="start">$</InputAdornment>,
        }}
        />
        </Grid>
        <Grid item xs={12} sm={12} >
            <TextField
        id="outlined-adornment-amount"
        className={classNames(classes.margin, classes.textField)}
        variant="outlined"
        label="Subtotal"
        value={this.state.selectedCctransaction.subTotal}
        onChange={this.handleChangeSubTotal}
        InputProps={{
            startAdornment: <InputAdornment position="start">$</InputAdornment>,
        }}
        />
        </Grid>
        <Grid item xs={12} sm={12} >
            <TextField
        id="outlined-adornment-amount"
        className={classNames(classes.margin, classes.textField)}
        variant="outlined"
        label="Tax Rate"
        value={this.state.selectedCctransaction.taxRate}
        onChange={this.handleChangeTaxRate}
        InputProps={{
            startAdornment: <InputAdornment position="start">%</InputAdornment>,
        }}
        />
        </Grid>
        <Grid item xs={12} sm={12} >
            <TextField
        id="outlined-adornment-amount"
        className={classNames(classes.margin, classes.textField)}
        variant="outlined"
        label="Taxes"
        value={this.state.selectedCctransaction.taxFee}
        onChange={this.handleChangeTaxFee}
        InputProps={{
            startAdornment: <InputAdornment position="start">$</InputAdornment>,
        }}
        />
        </Grid>
        <Grid item xs={12} sm={12} >
            <TextField
        id="outlined-adornment-amount"
        className={classNames(classes.margin, classes.textField)}
        variant="outlined"
        label="Total Amount"
        value={this.state.selectedCctransaction.totalCost}
        onChange={this.handleChangeTotalCost}
        InputProps={{
            startAdornment: <InputAdornment position="start">$</InputAdornment>,
        }}
        />
        </Grid>

        </Grid>

                <Grid container >

                    <Grid item xs={3} sm={3}>
                        <Button variant="contained" color="primary" onClick={this.handleSubmit} className={classes.button}  >
                        Add Cctransaction
                    </Button>
                    </Grid>
                    <Grid item xs={3} sm={3}>
                        <Button variant="contained" color="primary" onClick={this.handleUpdate} className={classes.button}  >
                        Update Cctransaction
                    </Button>
                    </Grid>
                    <Grid item xs={3} sm={3}>
                        <Button variant="contained" color="primary" onClick={this.clearFields} className={classes.button}  >
                        Clear Fields
                    </Button>
                    </Grid>
                    <Grid item xs={3} sm={3}>
                        <Button variant="contained" color="primary" onClick={this.refresh} className={classes.button}  >
                        Refresh
                        </Button>
                    </Grid>
                </Grid>
                <Grid container >
                     {  this.props.errorCMsg && (
                        <Grid item xs={12}   >
                        <TextField error id="outlined-error" label="Error - Operation Failed" value= {" message = " + this.props.errorCMsg.message + " details = " + this.props.errorCMsg.details + " Time = " +  this.props.errorCMsg.timestamp}
                            className={classes.textField} margin="normal"  variant="outlined" disabled={true}  multiline={true}/>
                        </Grid>)
                    }
                    {  !this.props.errorCMsg && (
                    <Grid item xs={12}   >
                        <TextField error id="outlined-error" label="Great! - Operation Success" value= "Nothing here"
                        className={classes.textField} margin="normal"  variant="outlined" disabled={true}  multiline={true}/>
                    </Grid>)
                    }
                </Grid>
                </Grid>
                <Grid item xs={12} sm={12}>
                    <DynamicTable  data={this.props.cctransactionsArray}  onEdit={this.editRecord}  onDelete={this.deleteRecord}> </DynamicTable>
                </Grid>

            </Grid>
        </React.Fragment>
    );
    }//end of render



    editRecord(singleRowData){
        this.setState({inputFieldShrinkState:true});
        this.setState({selectedCctransaction:singleRowData });
        //We need to change the seleted Location as well.
        //let tempLocation = this.props.locationsArray.find(x => x.locationId == singleRowData.locationId );

        //this.setState({selectedLocation:tempLocation });

    }


    deleteRecord(argProcessId){
        //alert('I am deleting ' + argCameraId);
        let { deleteACctransaction } = this.props;
        deleteACctransaction(DEFAULT_VESPAAN_SERVER.url,argProcessId  );
    }


    componentWillMount(){
        let { loadCctransactionsData , loadLocationsData } = this.props;
        loadCctransactionsData(DEFAULT_VESPAAN_SERVER.url );
        //loadLocationsData("http://localhost:9065/" );

            this.setState({
                errorCMsg:{}
            });


    }

    componentWillReceiveProps(nextProps) {
        if (this.props.cctransactionsArray !== nextProps.cctransactionsArray) {
            this.setState({
                cctransactionsArray: nextProps.cctransactionsArray
            });
        }
    }



}//end of class

CCTransactionForm.propTypes = {
    classes: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => {
    return {
        cctransactionsArray: state.cctransaction.cctransactionsArray,
        CctransactionDeleteResponse:state.cctransaction.deleteCctransactionResp,
        CctransactionSaveResponse:state.cctransaction.saveCctransactionResp,
        //locationsArray:state.location.locationsArray,
        //vcArray:state.videocontroller.vcArray,
        //camerasArray:state.camera.camerasArray,
        errorCMsg:state.cctransaction.errorCMsg,
    };
};

const mapDispatchToProps = (dispatch) => {
    return bindActionCreators({
        loadCctransactionsData:loadCctransactionsData,
        deleteACctransaction:deleteACctransaction,
        saveACctransaction:saveACctransaction,
        updateACctransaction:updateACctransaction,

    }, dispatch);
};

export default connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(CCTransactionForm));
